import type { HeadingBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface HeadingBlockEditorProps {
  content: HeadingBlockContent | null
  onChange: (content: HeadingBlockContent) => void
}

export function HeadingBlockEditor({ content, onChange }: HeadingBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<HeadingBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Heading</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Text</Label>
          <Input
            value={c.text ?? ""}
            onChange={(e) => update({ text: e.target.value })}
            placeholder="Section heading"
          />
        </div>
        <div>
          <Label>Level</Label>
          <Select
            value={String(c.level ?? 2)}
            onValueChange={(v) => update({ level: Number(v) as 1 | 2 | 3 | 4 | 5 | 6 })}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <SelectItem key={n} value={String(n)}>
                  H{n}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  )
}
